export enum RepeatType {
  NO = 'no-repeat',
  X = 'repeat-x',
  Y = 'repeat-y',
}
